import { render, staticRenderFns } from "./OperatorSupplierList.vue?vue&type=template&id=3b633cbf&scoped=true&lang=pug&"
import script from "./OperatorSupplierList.vue?vue&type=script&lang=ts&"
export * from "./OperatorSupplierList.vue?vue&type=script&lang=ts&"
import style0 from "./OperatorSupplierList.vue?vue&type=style&index=0&id=3b633cbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b633cbf",
  null
  
)

export default component.exports